module.exports = "https://cdn.thelire.com/ins/resource/feed_lucky_coins.4d4032a6d6a252dd63dd6ce3d4816fb7.png";